module.exports = "<div style=\"margin-top: 20px\" *ngIf=\"form\" >\n  <div>Detalhes do form</div>\n  <pre>Form válido: {{ form.valid }}</pre>\n  <!--pre>Form submetido: {{ form.submitted }}</pre -->\n  <pre>Valores: <br />{{ form.value | json }}</pre>\n</div>\n\n<!--  adicionar essa tag no form para debugar\n<app-form-debug [form]=\"f\"></app-form-debug>\n-->\n\n"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/area-restrita/shared/forms/form-debug/form-debug.component.html
// module id = ../../../../../src/app/area-restrita/shared/forms/form-debug/form-debug.component.html
// module chunks = main